'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


var _draftJs = require('draft-js');

var _checklistConstants = require('../checklistConstants');

/**
 * Handles the command for moving a selection to the end of the previous block.
 * This is used in scenarios where a custom block needs to prevent the content editable from treating certain elements
 * as navigateable via the cursor.
 * For example, the checklist component does not require the check box to be able to have the cursor before it, only
 * within the text.
 *
 * @param editorState {EditorState} The current editor state to modify.
 * @returns {EditorState} An updated editor state, or null if no updates are required.
 */
exports.default = function (editorState) {
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var contentState = editorState.getCurrentContent();
    var prevBlock = contentState.getBlockBefore(startKey);

    // If there's no previous block, then do nothing
    if (!prevBlock) return null;

    var prevKey = prevBlock.getKey();
    var prevLength = prevBlock.getLength();

    // Move the focus offset to the end of the previous line
    var selectionChanges = {
        focusKey: prevKey,
        focusOffset: prevLength
    };
    // If the selection is collapsed, keep it collapsed by also moving the anchor
    if (selection.isCollapsed()) {
        selectionChanges = _extends({}, selectionChanges, {
            anchorKey: prevKey,
            anchorOffset: prevLength
        });
    }

    var nextSelection = selection.merge(selectionChanges);

    // Update the selection state.
    var updatedEditorState = _draftJs.EditorState.forceSelection(editorState, nextSelection);
    return _draftJs.EditorState.push(updatedEditorState, contentState, _checklistConstants.COMMANDS.MOVE_SELECTION_TO_END_OF_PREVIOUS_BLOCK);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/checklist/utils/moveSelectionToEndOfPreviousBlock.js
// module id = 1726
// module chunks = 0